import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseApplicationsAndUrls from '../../AbstractObjects/GatewayPlan/InnerPages/BaseApplicationsAndUrls';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {applicationsAndUrlsIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.applicationsAndUrls;
const pageId = pageSchema.pageId;

function GatewayApplicationsAndUrls({
                                        gatewayObject,
                                        planObject,
                                        setGatewayData,
                                        setAppiDataValue
                                    }) {
    const {t} = useTranslation();
    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);

    return (
        <>
            <LockToPlanContainer
                locked={lockedToPlan}
                onToggleLocked={onToggleLockedToPlan}
                labelText={t('SMP.GATEWAYS.INNER_MENU.APPLICATIONS_AND_URLS')}
                icon={applicationsAndUrlsIcon}
            >
                <BaseApplicationsAndUrls
                    pageData={currentPageData}
                    setObjectData={setGatewayData}
                    pageDisabled={lockedToPlan}
                    setAppiDataValue={setAppiDataValue}
                />
            </LockToPlanContainer>
            <Indentation>
                <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.FWOverview')}><SMCIcon
                    style={{verticalAlign: 'middle'}} icon="seamlessLogin"/> {t('SMP.ACCESS_GATEWAY.APP_CONTROL')}
                </SMCLink>
            </Indentation>
        </>
    );
}

export default GatewayApplicationsAndUrls;